import { CapacitorUpdater } from '@capgo/capacitor-updater';
import safeStringify from 'fast-safe-stringify';
import appInsights from '@/AppInsights';
import { Device } from '@capacitor/device';

export async function checkForUpdate() {
	window.autoUpdateResult = {
		result: 'NOT-READY',
		timestamp: new Date().toISOString(),
		status: null,
	};
	const deviceInfo = await Device.getInfo();
	console.log('Device Info:', deviceInfo);
	if (deviceInfo.isVirtual) {
		console.warn('Skipping update check on emulator');
		window.isEmulator = true;
		return 'Warn: Skipping update check on emulator';
	}
	console.warn('Checking for update');
	const ready = await CapacitorUpdater.notifyAppReady();
	window.autoUpdateResult.result = ready;
	return 'Success';
}

export function getDeviceId() {
	return CapacitorUpdater.getDeviceId();
}

const listeners = [
	'appReloaded',
	'downloadFailed',
	'updateFailed',
	'majorAvailable',
	'downloadComplete',
	'updateAvailable',
	'noNeedUpdate',
	'download',
];
for (let index = 0; index < listeners.length; index++) {
	const listener = listeners[index];
	CapacitorUpdater.addListener(listener, (state) => {
		console.log(`Updater Event: ${listener}`, state);
		appInsights.trackTrace({
			message: `updater.${listener}`,
		});
		appInsights.trackEvent({
			name: `updater.${listener}`,
			properties: {
				...JSON.parse(safeStringify(state)),
			},
		});
	});
}
window.getLatestVersion = CapacitorUpdater.getLatest;
